import { TextField } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const DatePicker = ({ field, form, relationShip, ...props }) => {
  useEffect(() => {
    console.log("s", field);
  }, []);

  // Calculate the date 100 years ago using moment
  const minDate = moment().subtract(99, "years").toDate(); // Convert to native Date

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MobileDatePicker
        disableFuture
        minDate={minDate} // setting to 99 yrs back only
        id={field.name}
        name={field.name}
        value={field.value}
        inputFormat="DD-MMMM-YYYY"
        onChange={(newValue) => {
          form.setFieldValue(field.name, moment(newValue).format("MM-DD-YYYY"));
          let agefield = "" + field.name;
          agefield = agefield.split(".")[0] + ".Age";
          console.log("relationShip: ", relationShip);
          const birthDate = moment(newValue);
          const currentDate = moment();
          const age = currentDate.diff(birthDate, "years");
          const ageInDays = currentDate.diff(birthDate, "days");
          console.log("Setting", agefield, age, ageInDays);
          if (relationShip === "Dependent Child" && age > 25) {
            form.setFieldValue(field.name, "");
            form.setFieldValue(agefield, "");
            Swal.fire({
              icon: "warning",
              title:
                "Dependent Child age should be less than or equal to 25 years",
              position: "center",

              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              age = null;
            });
          } else if (
            relationShip === "Dependent Child" &&
            age < 1 &&
            ageInDays < 91
          ) {
            form.setFieldValue(field.name, "");
            form.setFieldValue(agefield, "");
            Swal.fire({
              icon: "warning",
              title: "Dependent Child age should be greater than 91 days",
              position: "center",

              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              age = null;
            });
          } else if (Number(age) === 0) {
            form.setFieldValue(agefield, "6 Month");
          } else {
            form.setFieldValue(agefield, age);
          }
          console.log("Setting2", agefield, age);
        }}
        renderInput={(params) => {
          //console.log('param',params)
          return (
            <TextField
              //touched={form.touched}
              name={field.name}
              id={field.name}
              sx={{
                /* "& label.Mui-focused": {
                                  display: "none"
                                }, */

                "& legend": {
                  display: "none",
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-error fieldset ": {
                    borderColor: "rgba(0, 0, 0, 0.23) !important", // default
                  },
                },
              }}
              //error={Boolean(currentError)}

              fullWidth
              {...params}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
